/**
 * Cache de la biblioteca y de los detalles ya vistos: volver a una pantalla muestra lo ultimo conocido
 * mientras se refresca (stale-while-revalidate) en vez de un "Cargando…" en blanco.
 */
import { defineStore } from "pinia";
import { ref, shallowRef } from "vue";

import { api } from "@/lib/api";
import type { ProductListItem, ProductResponse } from "@/lib/contracts";

export const useProductsStore = defineStore("products", () => {
  const list = shallowRef<ProductListItem[] | null>(null);
  const details = ref<Record<string, ProductResponse>>({});

  async function refreshList(): Promise<ProductListItem[]> {
    const { products } = await api.listProducts();
    list.value = products;
    return products;
  }

  async function refreshProduct(id: string): Promise<ProductResponse> {
    const data = await api.getProduct(id);
    details.value[id] = data;
    return data;
  }

  function forget(id: string): void {
    delete details.value[id];
    if (list.value) list.value = list.value.filter((p) => p.product_id !== id);
  }

  function reset(): void {
    list.value = null;
    details.value = {};
  }

  return { list, details, refreshList, refreshProduct, forget, reset };
});
